export class MetadataProjectDto {
    packageName: string;
    projectPath: string;
    projectName: string;
    projectNameSpace: string;
    depPackageName: string;
    depPackageVersion: string;
    depPackageLocation: string;

    // tslint:disable-next-line:max-line-length
    constructor(packageName: string, projectPath: string, projectName: string, projectNameSpace: string, depPackageName: string, depPackageVersion: string, depPackageLocation: string) {
        this.packageName = packageName;
        this.projectName = projectName;
        this.projectPath = projectPath;
        this.projectNameSpace = projectNameSpace;
        this.depPackageName = depPackageName;
        this.depPackageVersion = depPackageVersion;
        this.depPackageLocation = depPackageLocation;
    }
}
